import { RoleLayout } from '../../../components/Role';

export function Roles() {
  return <RoleLayout />;
}
